import Cookies from 'js-cookie';
import psl from 'psl';

const TokenKey = 'halo_token';

export function getToken() {
  // return localStorage.getItem('useEmail');
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  if (process.env.NODE_ENV === 'development') {
    return Cookies.set(TokenKey, token, { expires: 30 });
  } else {
    const parsed = psl.parse(location.host);
    const rootDomain = parsed.input;
    return Cookies.set(TokenKey, token, { expires: 30, path: '/', domain: `${rootDomain}` });
  }
}

export function removeToken() {
  Cookies.remove(TokenKey);

  if (process.env.NODE_ENV === 'development') {
    return Cookies.remove(TokenKey);
  } else {
    // if (location.host === 'web.test.com') {
    //   return Cookies.remove(TokenKey, { domain: '.web.test.com' });
    // } else {
    //   return Cookies.remove(TokenKey, { domain: `.${location.host}` });
    // }
    Cookies.remove(TokenKey, { domain: `.texturenoise.com` });
    return Cookies.remove(TokenKey, { domain: `.${location.host}` });
  }
}
